import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";

function Reports() {
  const { searchParamString } = usePagination();
  const { api, auth } = useApi();

  const getReports = async (searchString) => {
    try {
      const url = `/reports${searchString}`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: reports } = useQuery(
    ["reports", searchParamString, auth],
    ({ queryKey }) => getReports(queryKey[1])
  );

  return (
    auth?.user && (
      <section id="content" className="content">
        <div className="content__header content__boxed overlapping">
          <div className="content__wrap">
            <h1 className="page-title mb-2">Reports</h1>
            <h2 className="h5">Intuitive reports</h2>
            <p>
              Select the desired the report to begin
              <br />
            </p>
          </div>
        </div>

        <div>
          <div className="content__boxed">
            <div className="content__wrap">
              <div className="row my-3">
                {reports &&
                  reports.map((report) => (
                    <div className="col-md-4 col-lg-3 mb-3" key={report.id}>
                      <Link to={report.link} className="text-decoration-none">
                        <div className="card text-center mb-3 mb-md-0">
                          <div className="card-body">
                            <div className="h1 my-4">
                              <i className="display-3 text-head text-opacity-20 text-orange demo-psi-bar-chart"></i>
                            </div>
                            <p className="h4" style={{ height: 30 }}>
                              {report.name}
                            </p>

                            <small
                              className="d-block text-muted my-3"
                              style={{ height: 40 }}
                            >
                              {report.info}
                            </small>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  );
}

export default Reports;
